var FavoritesEnum = /* @__PURE__ */ ((FavoritesEnum2) => {
  FavoritesEnum2["FAVORITES_LOCAL_CONTAINER"] = "local-container";
  FavoritesEnum2["FAVORITES_BRANCH_CONTAINER"] = "branch-container";
  FavoritesEnum2["FAVORITES_PROFESSIONAL_CARD"] = "professional-card";
  FavoritesEnum2["FAVORITES_SHOW_MORE_BUTTON"] = "show-more-button";
  FavoritesEnum2["FAVORITES_LIKE_BUTTON"] = "favorites-like-button";
  FavoritesEnum2["FAVORITES_LOCALS_GROUP"] = "locals-group";
  FavoritesEnum2["FAVORITES_PROFESSIONALS_GROUP"] = "professionals-group";
  FavoritesEnum2["FAVORITES_LOADER"] = "loader-favorites";
  FavoritesEnum2["FAVORITES_EMPTY_STATE"] = "empty-favorites";
  return FavoritesEnum2;
})(FavoritesEnum || {});
export {
  FavoritesEnum
};
